import axios, {AxiosInstance, AxiosRequestConfig, AxiosError} from 'axios'
import store from '../redux/Store'

const axiosClient: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL_BACKEND_LOCAL,
  timeout: 10000,
})

axiosClient.interceptors.request.use(
  (config: AxiosRequestConfig) => {
    const {
      auth: {accessToken},
    } = store.getState()

    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`
    }

    return config
  },
  (error: AxiosError) => Promise.reject(error)
)

axiosClient.interceptors.response.use(
  (response) => response,
  (error: AxiosError<any>) => {
    const message =
      error.response?.data?.message || error.response?.data?.data?.message || error.message

    return Promise.reject({
      status: error.response?.status,
      message,
      raw: error,
    })
  }
)

export default axiosClient
